import React from 'react';
import { Heart, Eye, Users } from 'lucide-react';

import { useRef, useEffect, useState } from 'react';
import AnimatedNumber from './AnimatedNumber';

export default function StatsBar({
  coinName,
  currentPrice,
  priceChange,
  tags = [],
  watchlistCount,
  participantCount,
  watchlisted,
  onToggleWatchlist
}) {
  // 动画状态
  const [flash, setFlash] = useState(''); // '', 'up', 'down'
  const prevPrice = useRef(currentPrice);

  useEffect(() => {
    if (prevPrice.current === undefined || currentPrice === undefined) {
      prevPrice.current = currentPrice;
      return;
    }
    if (currentPrice > prevPrice.current) {
      setFlash('up');
    } else if (currentPrice < prevPrice.current) {
      setFlash('down');
    }
    prevPrice.current = currentPrice;
    if (currentPrice !== undefined) {
      const timer = setTimeout(() => setFlash(''), 1000);
      return () => clearTimeout(timer);
    }
  }, [currentPrice]);

  return (
    <div className="flex items-center justify-between mb-4">
      {/* 动画关键帧 */}
      <style>{`
        .flash-up {
          animation: flashGreen 1s;
        }
        .flash-down {
          animation: flashRed 1s;
        }
        @keyframes flashGreen {
          0% { background-color:rgba(34, 197, 94, 0.2); }
          100% { background-color: transparent; }
        }
        @keyframes flashRed {
          0% { background-color:rgba(239, 68, 68, 0.2); }
          100% { background-color: transparent; }
        }
      `}</style>
      {/* 左侧：收藏 + 币名 + 现价 + 涨幅 */}
      <div className="flex items-center space-x-3">
        <button 
          onClick={onToggleWatchlist}
          className={`transition-colors ${
            watchlisted ? 'text-yellow-400 hover:text-yellow-300' : 'text-gray-400 hover:text-white'
          }`}
        >
          <Heart className={`w-4 h-4 ${watchlisted ? 'fill-current' : ''}`} />
        </button>
        <div className="flex items-center space-x-3">
          <div className="font-bold text-lg text-white">{coinName}</div>
          <div className="flex items-center space-x-2">
            <span
              className={`px-2 py-1 rounded text-sm font-medium text-white transition-all duration-300
                ${flash === 'up' ? 'bg-green-500/70' : flash === 'down' ? 'bg-red-500/70' : 'bg-white/10'}`}
              style={{ transition: 'background-color 1s cubic-bezier(.4,0,.2,1)' }}
            >
              <AnimatedNumber value={currentPrice} prefix="U" />
            </span>
            <span className={`px-2 py-1 rounded text-sm font-medium ${
              priceChange?.startsWith('+') 
                ? 'bg-green-500/20 text-green-300' 
                : priceChange?.startsWith('-') 
                ? 'bg-red-500/20 text-red-300' 
                : 'bg-gray-500/20 text-gray-300'
            }`}>
              {priceChange}
            </span>
          </div>
        </div>
      </div>
      {/* 右侧：标签 + 统计数据 */}
      <div className="flex items-center space-x-3">
        {/* 币种标签 */}
        <div className="flex items-center space-x-1">
          {tags.map((tag, index) => (
            <span 
              key={index}
              className="bg-blue-500/20 text-blue-300 px-2 py-1 rounded text-xs font-medium"
            >
              {tag}
            </span>
          ))}
        </div>
        {/* 统计数据 */}
        <div className="flex items-center space-x-3 text-xs text-gray-400">
          <div className="flex items-center space-x-1">
            <Eye className="w-3 h-3" />
            <span>{watchlistCount?.toLocaleString()}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Users className="w-3 h-3" />
            <span>{participantCount?.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
